import React, { useEffect, useState } from 'react';
import Styled from 'styled-components'
import CreditForm from './CreditForm';
import { device } from '../../../../app/js/utils/responsive_utilities';
import { fontQuicksand } from '../../common/mixins/mixin';

const CreditCardsContainer = ({
  selectCardHandler,
  paymentHandler,
  selectedPlan,
  settings,
  error,
  setError
  }) => {

  //to get saved and default card id
  useEffect(() => {
    setError(null);
  }, [])

  return (
    <PaymentContainer>
      <CreditForm
        paymentHandler={paymentHandler}
        settings={settings}
        selectedPlan={selectedPlan}
        error={error}
        setError={setError}
      />
    </PaymentContainer>
  )
}

export const SavedCard = Styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  background-color: ${props => props.isSelected ? "rgba(79, 82, 195, 0.4)" : 'transparent'};
  margin-bottom: 1.6rem;
  border: 0.1rem solid #6E71DD;
  border-radius: 1.2rem;
  height: 7.2rem;
  padding: 0 2.4rem;
  ${fontQuicksand(1.6, 2, 7)};
  color: #fff;
  .card-brand-logo-new-page {
    padding: 0;
    width: 5.5rem;
    height: 4rem;
  }
  input[type="radio"] {
    opacity: 0;
    width:0;
    height:0;

  }
  input[type="radio"]:checked + label::after {
    border-width: 0.4rem;
    background-color: #2284E2;
  }

  label {
    cursor: pointer;
    position: relative;
    padding-left: 2rem;
    &:after {
      content: '';
      width: 1.6rem;
      height: 1.6rem;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      border: 0.1rem solid #fff;
      border-radius: 50%;
      box-sizing: border-box;
      background-color: transparent;
    }
  }
  p {
    display: inline-block;
  }
  .hidden-card-nmbr {
    ${fontQuicksand(2.4, 2.8, 7)};
    vertical-align: sub;
  }
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.4, 1.8, 7)};
    height: 48px;
    .hidden-card-nmbr {
    ${fontQuicksand(1.8, 2.2, 7)};
  }
  }
  @media ${device.Phone} {
  ${fontQuicksand(1.4, 1.8, 7)};
  height: 48px;
  .hidden-card-nmbr {
    ${fontQuicksand(1.8, 2.2, 7)};
  }
  }
`;
export const PaymentContainer = Styled.div`
  width: 100%;
  margin: 1rem auto;
  & > form{
    width: 100%;
  }
  
`;
export const SavedCardsWrapper = Styled.ul`
  width: 47rem;
  box-sizing: border-box;
  margin: 0 auto;
  
  @media ${device.PhoneLargeScreen} {
    width: 3.7rem;
  }
  @media ${device.Phone} {
    width: 34rem;
  }
`;
export default CreditCardsContainer;